export const initialState = {
  rips: {
    body: {
      content: []
    },
    errorAlert: {
      isAxiosError: false
    },
    loading: false
  },
  filters: {
    branches: {
      content: [],
      errorAlert: false,
      loading: false
    },
    healthcareProviders: {
      content: [],
      errorAlert: false,
      loading: false
    }
  },
  filtersKeep: JSON.parse(localStorage.getItem('filters')) || '',
  files: {
    errorAlert: false,
    loading: false
  }
}

export default {
  ...initialState
}
